import { type MouseEvent, type PointerEvent, useRef } from 'react';
import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { IconButton } from '@ev-tech/ui-core-components/IconButton';
import { CrossNakedIcon as CloseIcon } from '@ev-tech/search-modules-shared/Icons';

import styles from './AutoComplete.module.css';

type ClearInputButtonProps = {
  onClick?: () => void;
  'data-testid'?: string;
};

export const ClearInputButton = ({ onClick, 'data-testid': dataTestId }: ClearInputButtonProps) => {
  const clearButtonRef = useRef(null);
  const { t } = useAppContext();

  const preventOutsideDismiss = (e: MouseEvent | PointerEvent) => {
    // Reason: Keep input focus (iOS) and stop Base UI treating clear as an outside press
    // that closes the popover — which would unmount this button before click fires.
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <span onPointerDownCapture={preventOutsideDismiss} onMouseDownCapture={preventOutsideDismiss}>
      <IconButton
        as="button"
        className={styles.clearButton}
        ref={clearButtonRef}
        icon={<CloseIcon />}
        variant="primaryAlt"
        shape="square"
        label={t('search.searchbar.locationInput.clear')}
        size="xsmall"
        data-autocomplete-clear-button
        data-testid={dataTestId}
        type="button"
        onClick={onClick}
      />
    </span>
  );
};
